import Button from 'components/ReusableComponents/Button'
import PromotionIcon from 'features/Widgets/WidgetsCard/PromotionIcon'
import { useInternalAdmin } from 'hooks'
import { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import AddCreditsDialog from './AddCreditsDialog'
import styles from './DripCountIndicator.module.scss'

const DripCountIndicator = ({
  dripCount,
  isDefaultCampaigns,
  setIsCreateNewCampaignDialogVisible,
  onCreditsUpdated
}) => {
  const location = useLocation()
  const history = useHistory()

  const isInternalAdmin = useInternalAdmin()
  const [isAddCreditsDialogVisible, setIsAddCreditsDialogVisible] = useState(false)

  const inviteMessagesRoute = `/${
    isDefaultCampaigns ? 'defaultCampaigns' : 'manageCampaigns'
  }/sales`
  const dripCampaignsRoute = '/custom-campaigns'

  const inviteMessagesLocation =
    location.pathname + location.search === inviteMessagesRoute
  const dripCampaignsLocation = location.pathname + location.search === dripCampaignsRoute

  const handleClick = () => {
    if (inviteMessagesLocation && !isDefaultCampaigns) {
      history.push('/custom-campaigns')
    }
    if (dripCampaignsLocation) {
      setIsCreateNewCampaignDialogVisible(true)
    }
  }

  if (isInternalAdmin) {
    return (
      <>
        <div className={styles.dripCountContainer}>
          <div className={styles.dripCountIndicator}>
            <PromotionIcon withoutCircle={true} />
            Hotel has {dripCount || 'no'} complimentary texts available for a drip
            campaign.
          </div>
          <Button
            className={styles.campaignButton}
            type="secondary"
            size="small"
            onClick={() => setIsAddCreditsDialogVisible(true)}
          >
            Add credits
          </Button>
        </div>
        {isAddCreditsDialogVisible && (
          <AddCreditsDialog
            currentCredits={dripCount}
            onClose={() => setIsAddCreditsDialogVisible(false)}
            onSuccess={onCreditsUpdated}
          />
        )}
      </>
    )
  }
  return (
    <div className={styles.dripCountContainer}>
      <div className={styles.dripCountIndicator}>
        <PromotionIcon withoutCircle={true} />
        You have {dripCount || 'no'} complimentary texts available for a drip campaign.
      </div>
      <Button
        className={styles.campaignButton}
        type="secondary"
        size="small"
        onClick={handleClick}
      >
        Create a drip campaign
      </Button>
    </div>
  )
}

export default DripCountIndicator
